import { classNames } from "@/react/helpers/twMergeWithCN";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { ConversationsListPage } from "../pages/ConversationsListPage";
import { HelpWidgetLayout } from "./common/HelpWidgetLayout";

interface ConversationLayoutProps {
  children: React.ReactNode;
}

export const ConversationLayout = ({ children }: ConversationLayoutProps) => {
  const { isExpanded, isSidebarOpen } = useHelpWidgetContext();

  return (
    <div className="scrollbar-hide flex h-full flex-col overflow-y-auto">
      <div className="flex size-full">
        {isExpanded && (
          <div
            className={classNames(
              "border-primary border-r transition-all duration-300 ease-in-out",
              {
                "w-[312px]": isSidebarOpen,
                "w-0 opacity-0": !isSidebarOpen,
              },
            )}
          >
            <div className="h-full overflow-y-auto">
              <ConversationsListPage />
            </div>
          </div>
        )}
        <HelpWidgetLayout className="flex-1">
          <div className="scrollbar-hide flex h-full flex-col items-end overflow-y-auto">
            {children}
          </div>
        </HelpWidgetLayout>
      </div>
    </div>
  );
};
